const SinglePost = {
  init: function () {
    this.slider();
    this.share();
  },

  slider: function () {
    let slider_dom = $(".news-slider");
    if (slider_dom.length) {
      require(["swiper"], function (Swiper) {
        let nav_prev = slider_dom.find(".swiper-button-prev");
        let nav_next = slider_dom.find(".swiper-button-next");
        let relited_slider = new Swiper(slider_dom, {
          spaceBetween: 30,
          loop: true,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            prevEl: nav_prev,
            nextEl: nav_next,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
          },
        });
      });
    }
  },

  share: function () {
    if ($(".soc-share").length) {
      $("body").on("click", ".soc-share", function (e) {
        e.preventDefault();

        let platform = $(this).attr("data-platform");
        let data = $(this).attr("data-content");

        helpers.share(platform, data);
      });
    }
  },
};

export default SinglePost;
